import React, { useCallback, useEffect, useMemo } from 'react'
import { useField } from 'formik'
import PropTypes from 'prop-types'
import SelectorUI from './SelectorUI'

const findOption = (options, value) =>
  options?.find((item) => item.id === value) || null

export default function SelectorField({ boxShadow, border = null, ...props }) {
  const [field, , { setValue }] = useField(props)
  const handleChange = useCallback(
    (newValue) => {
      if (newValue === null) {
        setValue(props.defaultValue || null)
      } else {
        setValue(newValue?.id || newValue?.id === '' ? newValue?.id : null)
      }
    },
    [setValue],
  )
  const selected = useMemo(() => {
    return findOption(props?.options, field.value)
  }, [field])

  useEffect(() => {
    if (props?.defaultValue) {
      setValue(
        props?.defaultValue || props?.defaultValue === ''
          ? props?.defaultValue
          : null,
      )
    }
  }, [])

  useEffect(() => {
    if (props?.handleChange) {
      props?.handleChange?.(field.value)
    }
  }, [field.value])

  return (
    <SelectorUI
      {...field}
      selectorProps={{
        ...props,
        value: selected,
        onChange: handleChange,
      }}
      placeholder={props.placeholder}
      title={props.title}
      titleType={props.titleType}
      boxShadow={boxShadow}
      border={border}
    />
  )
}
SelectorField.propTypes = {
  boxShadow: PropTypes.string,
  border: PropTypes.string,
  defaultValue: PropTypes.string,
  handleChange: PropTypes.func,
  options: PropTypes.array,
  placeholder: PropTypes.oneOfType([PropTypes.string]),
  title: PropTypes.string,
  titleType: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}
